import styled from 'styled-components';

import Box from 'ravenjs/lib/Box';

// Define styles for the AccordionContent.
const AccordionContentStyled = styled(Box)``;

export default AccordionContentStyled;
